const initializePopupIndex = (section) => {
  console.log("initializePopupIndex");
  console.log(section);
  const sectionEl = document.querySelector(`#shopify-section-${section.id}`);
  const elements = document.querySelectorAll("div[data-popup-index-title]");
  if (!elements || elements.length <= 0) {
    sectionEl.style.display = "none";
    return;
  }
  sectionEl.style.display = "flex";
  document.documentElement.classList.add("fs-smooth-scroll");

  const rows = [];
  elements.forEach((element) => {
    const title = element.dataset.popupIndexTitle;
    const id = element.parentElement.id;
    const row = `<a class="popup-index-row" href="#${id}">${title}</a>`;
    rows.push(row);
  });

  const rowsEl = sectionEl.querySelector(".popup-index-rows");
  rowsEl.innerHTML = rows.join("");
};

/*
 * Main
 */

addEventListener("DOMContentLoaded", () => {
  console.log("hoge");
  window.fstore.sections.forEach((section) => {
    if (section.sectionType == "popup-index") {
      initializePopupIndex(section);
    }
  });
});
